import { makeStyles } from '~/UIKit/Style';
import { PRIMARY_BLUE, WHITE, FADED_FITOGRAM_BLUE } from '../../Constants/Colors.constants';

const stepWidth = '2em';
const borderThickness = '3px';

interface ProgressBarWrapperProps {
  hideImage: boolean;
}
export const progressBarWrapper = ({ hideImage = false }: ProgressBarWrapperProps) =>
  makeStyles((theme) => ({
    wrapper: {
      position: 'relative',
      margin: '30px auto',
      display: 'flex',
      zIndex: 0,
    },
    image: {
      display: hideImage ? 'none' : 'block',
      position: 'absolute',
      top: '-1.5em',
      right: '12%',
      height: '100%',
      [theme.breakpoints.down('md')]: {
        right: '.5em',
      },
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
  }));

export const progressBarContainer = () =>
  makeStyles((theme) => ({
    container: {
      display: 'flex',
      position: 'relative',
      alignItems: 'center',
      justifyContent: 'space-between',
      margin: '0 22%',
      flex: 1,
      [theme.breakpoints.down('md')]: {
        margin: '0 10%',
        marginBottom: '2em',
      },
      [theme.breakpoints.down('md')]: {
        margin: '0 3%',
        marginBottom: '1em',
      },
    },
  }));

interface ProgressBarStepProps {
  active: boolean;
  completed: boolean;
}
export const progressBarStep = ({ active, completed }: ProgressBarStepProps) =>
  makeStyles((theme) => {
    const sizing = `calc(${stepWidth} - calc(${borderThickness} * 2))`;

    return {
      stepContainer: {
        zIndex: 1,
        flexBasis: '14%',
      },

      step: {
        width: sizing,
        height: sizing,
        fontSize: '16px',
        backgroundColor: WHITE,
        border: `${borderThickness} solid ${
          active || completed ? PRIMARY_BLUE : FADED_FITOGRAM_BLUE
        }`,
        borderRadius: '100px',
        color: `${active || completed ? PRIMARY_BLUE : FADED_FITOGRAM_BLUE}`,
        textAlign: 'center',
        lineHeight: sizing,
        boxSizing: 'content-box',
        margin: 'auto',
        marginBottom: '.3em',
        [theme.breakpoints.down('md')]: {
          width: `${!completed ? '22px' : '15px'}`,
          height: `${!completed ? '22px' : '15px'}`,
          backgroundColor: `${completed ? PRIMARY_BLUE : WHITE}`,
          fontSize: `${!completed ? '12px' : 0}`,
          margin: `0 auto .3em auto`,
          border: `${borderThickness} solid ${active ? PRIMARY_BLUE : FADED_FITOGRAM_BLUE}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },

      text: {
        display: 'block',
        textAlign: 'center',
        fontSize: '13px',
        fontWeight: active ? 'bold' : 'normal',
        [theme.breakpoints.down('md')]: {
          display: 'none',
        },
      },
    };
  });

interface ProgressBarSectionProps {
  numberOfSteps: number;
  stepIndex: number;
  complete: boolean;
}

export const progressBarSection = ({
  numberOfSteps,
  stepIndex,
  complete,
}: ProgressBarSectionProps) =>
  makeStyles(() => {
    const barWidth = `calc(((100% - 7%) - (${stepWidth} * ${numberOfSteps})) / ${
      numberOfSteps - 1
    } + ${stepWidth})`;
    const height = `calc(${borderThickness} * 2)`;
    const left = `calc((${stepWidth} / 2) + (${stepIndex - 1} * ${barWidth}) + 3.5%)`;

    return {
      progressBarSection: {
        position: 'absolute',
        top: '13px',
        backgroundColor: complete ? PRIMARY_BLUE : FADED_FITOGRAM_BLUE,
        height,
        flex: '0 0',
        zIndex: 0,
        width: barWidth,
        left,
      },
    };
  });
